import React from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCardTitle,
  CForm,
  CFormGroup, CImg, CLabel,
  CSwitch, CTooltip,
} from '@coreui/react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import classNames from 'classnames';
import Select from '../../shared/components/form/select/Select';
import { JobPhase, JobPhaseLabel } from '../../shared/models/jobs';
import { CustomizationFormProps } from '../types';
import tooltip from '../../assets/images/tool_tip.svg';


const options = [
  {
    value: JobPhase.Live,
    label: JobPhaseLabel[JobPhase.Live],
  },
  {
    value: JobPhase.Arrived,
    label: JobPhaseLabel[JobPhase.Arrived],
  },
];


const ChatForm = () => {
  const formik = useFormikContext();

  const errors = formik.errors as CustomizationFormProps;

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    <CForm onSubmit={formik.handleSubmit}>
      <CCard className="glympser-container--roundedWithShadow">
        <CCardHeader className="glympser-roundedTop">
          <div className="d-flex align-items-center justify-content-between">
            <CCardTitle className="m-0">
              Chat
            </CCardTitle>
          </div>
        </CCardHeader>
        <CCardBody>
          <CFormGroup>
            <div className="d-flex align-items-center">
              Enable:
              <CSwitch
                type="checkbox"
                className="ml-1"
                {...formik.getFieldProps({
                  name: 'chatPhasesEnabled',
                  type: 'checkbox',
                })}
              />
            </div>
          </CFormGroup>
          <CFormGroup>
            <CLabel htmlFor="chat-phases">
              Phases
              <CTooltip placement="top" content="Select phases when a chat will be available.">
                <CImg src={tooltip} className="ml-2 glympser-toolTip" />
              </CTooltip>
            </CLabel>
            <Select
              isMulti
              name="chat-phases"
              id="chat-phases"
              options={options}
              className={classNames({ 'is-invalid': isInvalid('chatPhases') })}
              classNamePrefix="select"
              {...formik.getFieldProps('chatPhases')}
              onBlur={() => formik.setFieldTouched('chatPhases', true, true)}
              onChange={(selectedValues) => formik.setFieldValue('chatPhases', selectedValues)}
              isDisabled={!formik.getFieldProps('chatPhasesEnabled')?.value}
            />
            {isInvalid('chatPhases') && <div className="invalid-feedback">{errors.chatPhases}</div>}
          </CFormGroup>
        </CCardBody>
      </CCard>
    </CForm>
  );
};

export default ChatForm;
